<template>
  <svg
    :class="svgClass"
    :style="svgStyle"
    aria-hidden="true"
  >
    <use
      :xlink:href="iconName"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { propTypes } from '../../utils/propTypes.ts';

const props = defineProps({
  iconClass: propTypes.string.isRequired,
  className: propTypes.string.def(''),
  color: propTypes.string.def(''),
});
const iconName = computed(() => `#icon-${props.iconClass}`);
const svgClass = computed(() => {
  if (props.className) {
    return `${props.className} svg-icon`;
  }
  return 'svg-icon';
});
const svgStyle = computed(() => {
  if (props.iconClass === 'material') {
    return {
      width: '1.25em',
      height: '1.25em',
      verticalAlign: '-4px',
    };
  }
  return undefined;
});
</script>

<style lang="scss" scoped>
.sub-el-icon,
.nav-icon {
  display: inline-block;
  font-size: 15px;
  margin-inline-end: 12px;
  position: relative;
}

.svg-icon {
  width: 1em;
  height: 1em;
  position: relative;
  fill: currentColor !important;
  vertical-align: -2px;
}
</style>
